import React, { useState } from 'react';
import { connect } from 'react-redux';
import { getCookie, setCookie } from 'redux-cookie';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import store from '../../redux/store';
import { parseSanitizedHTML, currentDate, isDateBetweenDateRange } from '../../utils/Helper';
import './Notification.scss';

const Toast = ({ title, content, closeAlertBar }) => {
  return (
    <div className="alert-bar">
      <div className="content-wrapper">
        <div className="alert-bar__holder">
          <div className="alert-bar__title">{title}</div>
          <div className="alert-bar__desc">{parseSanitizedHTML(content)}</div>
          <div className="alert-bar__control">
            <button
              type="button"
              title="Close Announcement Bar"
              onClick={closeAlertBar}
              className="alert-bar__close"
            >
              <span className="visually-hidden">Close</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const Popup = ({ title, content, closeAlertBar }) => {
  return (
    <Modal size="lg" isOpen toggle={closeAlertBar} className="noticeModal" scrollable centered>
      <ModalHeader toggle={closeAlertBar}>{title}</ModalHeader>
      <ModalBody>{parseSanitizedHTML(content)}</ModalBody>
      <ModalFooter>
        <Button color="secondary" size="sm" onClick={closeAlertBar}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const Notification = ({ ...props }) => {
  const [showAlertBar, setShowAlertBar] = useState(true);
  const { data, i18n } = props;
  const { locale } = i18n || {};
  const { shownOnRefresh, latestModifiedDate, id, displayStyle } = data;
  const serverTime = currentDate();
  const startTimeString = data['start-time'] || '';
  const endTimeString = data['end-time'] || '';
  const txtCopy = data[locale] || {};
  const { title, content } = txtCopy;

  const closeAlertBar = () => {
    setShowAlertBar(false);
    if (!shownOnRefresh) {
      store.dispatch(setCookie(`${id}_AlertLatestModifiedDate`, latestModifiedDate));
    }
  };

  const isValidDate = isDateBetweenDateRange(startTimeString, endTimeString, serverTime);

  const currentLatestModifiedDate = shownOnRefresh
    ? ''
    : store.dispatch(getCookie(`${id}_AlertLatestModifiedDate`)) || '';

  const needShow = isValidDate
    ? !currentLatestModifiedDate || currentLatestModifiedDate !== latestModifiedDate
    : false;

  const showNotice = needShow && showAlertBar;

  return (
    <>
      {showNotice && displayStyle === 2 && (
        <Popup title={title} content={content} closeAlertBar={closeAlertBar} />
      )}
      {showNotice && displayStyle !== 2 && (
        <Toast title={title} content={content} closeAlertBar={closeAlertBar} />
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  i18n: state.i18n,
});

const connectStore = connect(mapStateToProps, null, null, {
  pure: true,
})(Notification);

export { Notification as NotificationComponent }; // <- For component Unit Test
export default connectStore;
